document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById("ContactModal");
  var closeBtn = document.querySelector(".close-modal-btn");
  var triggerBtns = document.querySelectorAll(".trigger-contact-modal");

  var successBox = document.getElementById("ZohoSuccessMessage");
  var formGrid = document.getElementById("ZohoFormGrid");
  var formEl = document.getElementById("ZohoDeskWebToCaseForm");
  var submitBtn = document.getElementById("ZohoSubmitBtn");
  var descEl = document.getElementById("ZohoDescription");
  var iframeEl = document.getElementById("ZohoHiddenFrame");

  var isSubmitting = false;
  var submitTimer = null;

  function openModal() {
    if (modal) modal.style.display = "flex";
  }

  function closeModal() {
    if (modal) modal.style.display = "none";
  }

  function resetSubmitBtn() {
    if (submitBtn) {
      submitBtn.removeAttribute('disabled');
      submitBtn.style.opacity = '';
      submitBtn.style.cursor = '';
      submitBtn.style.display = '';
    }
  }

  function setSubmittingState() {
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.style.opacity = '0.7';
      submitBtn.style.cursor = 'not-allowed';
    }
  }

  function showSuccessState() {
    if (successBox) successBox.style.display = "block";
    if (formGrid) formGrid.style.display = "none";
    if (submitBtn) submitBtn.style.display = "none";

    setTimeout(function() {
      closeModal();
      if (successBox) successBox.style.display = "none";
      if (formGrid) formGrid.style.display = "grid";
      resetSubmitBtn();
      if (formEl) formEl.reset();
    }, 4000);
  }

  triggerBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (successBox) successBox.style.display = "none";
      if (formGrid) formGrid.style.display = "grid";
      resetSubmitBtn();
      openModal();
    });
  });

  if (closeBtn) {
    closeBtn.onclick = closeModal;
  }

  window.addEventListener('click', function(event) {
    if (event.target === modal) closeModal();
  });

  function buildZohoDescription() {
    var company = document.getElementById('ContactFormCompany')?.value || '';
    var name = document.getElementById('ContactFormName')?.value || '';
    var email = document.getElementById('ContactFormEmail')?.value || '';
    var phone = document.getElementById('ContactFormPhone')?.value || '';
    var reg = document.getElementById('ContactFormRegCountry')?.value || '';
    var dest = document.getElementById('ContactFormDestCountry')?.value || '';
    var biz = document.getElementById('ContactFormBusinessType')?.value || '';
    var subject = document.getElementById('ContactFormSubject')?.value || '';
    var msg = document.getElementById('ContactFormMessage')?.value || '';
    var pageUrl = window.location.href.split('?')[0];

    var lines = [];
    if (msg) lines.push(msg);
    lines.push("");
    lines.push("----");
    if (subject) lines.push("Subject: " + subject);
    if (company) lines.push("Company: " + company);
    if (name) lines.push("Contact Name: " + name);
    if (email) lines.push("Email: " + email);
    if (phone) lines.push("Phone: " + phone);
    if (reg) lines.push("Registration Country: " + reg);
    if (dest) lines.push("Sales Destination: " + dest);
    if (biz) lines.push("Business Type: " + biz);
    lines.push("Page URL: " + pageUrl);
    lines.push("Submitted At: " + new Date().toISOString());

    return lines.join("\n");
  }

  function validateBasic() {
    var company = document.getElementById('ContactFormCompany');
    var name = document.getElementById('ContactFormName');
    var email = document.getElementById('ContactFormEmail');
    var phone = document.getElementById('ContactFormPhone');
    var subject = document.getElementById('ContactFormSubject');
    var reg = document.getElementById('ContactFormRegCountry');
    var dest = document.getElementById('ContactFormDestCountry');
    var biz = document.getElementById('ContactFormBusinessType');

    if (!company || !company.value.trim()) { company && company.focus(); return false; }
    if (!name || !name.value.trim()) { name && name.focus(); return false; }
    if (!email || !email.value.trim()) { email && email.focus(); return false; }

    var re = /^([\w_][\w\-_.+'&]*)@(?=.{4,256}$)(([\w]+)([\-_]*[\w])*[.])+[a-zA-Z]{2,22}$/;
    if (!re.test(email.value.trim())) { email.focus(); return false; }

    if (!phone || !phone.value.trim()) { phone && phone.focus(); return false; }

    var phoneRe = /^[+]?[0-9()\s-]{6,20}$/;
    if (!phoneRe.test(phone.value.trim())) { phone.focus(); return false; }

    if (!subject || !subject.value.trim()) { subject && subject.focus(); return false; }

    if (reg && (reg.value === '' || reg.value === '-None-')) { reg.focus(); return false; }
    if (dest && (dest.value === '' || dest.value === '-None-')) { dest.focus(); return false; }
    if (biz && (biz.value === '' || biz.value === '-None-')) { biz.focus(); return false; }

    return true;
  }

  if (iframeEl) {
    iframeEl.addEventListener('load', function() {
      if (!isSubmitting) return;

      clearTimeout(submitTimer);
      isSubmitting = false;
      showSuccessState();
    });
  }

  if (formEl) {
    formEl.addEventListener('submit', function(e) {
      if (!validateBasic()) {
        e.preventDefault();
        return;
      }

      if (descEl) {
        descEl.value = buildZohoDescription();
      }

      var returnEl = document.getElementById('ZohoReturnURL');
      if (returnEl) {
        returnEl.value = '';
      }

      isSubmitting = true;
      setSubmittingState();

      clearTimeout(submitTimer);
      submitTimer = setTimeout(function() {
        if (isSubmitting) {
          isSubmitting = false;
          resetSubmitBtn();
          alert('Submission failed, please try again.');
        }
      }, 15000);
    });
  }
});